import { useCreateOperator } from '../../../../../../contexts/CreateOperatorContext';
import { DynamicForm } from '../../../DynamicForm';
import { SettingItemList } from '../../../SettingItemList';
import React from 'react';
import { CloudDvr } from './CloudDvr';
import { Cloud } from '@material-ui/icons';
import { CsvImportButton } from '../../../../CsvImportButton';
import { CollapsableContent } from '../../../../../../components/CollapsableContent/CollapsableContent';

export const CloudDvrs = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  if (operator.mediaFirstSettings === undefined) return null;

  const handleRemovePkg = (dvrIndex: number) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        cloudDvrs: (operator.mediaFirstSettings?.cloudDvrs ?? []).filter(
          (value, index) => index !== dvrIndex
        ),
      })
    );
  };

  const handleSavePkg = (item: CreateCloudDvr, dvrIndex: number) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        cloudDvrs: (operator.mediaFirstSettings?.cloudDvrs ?? []).map(
          (value, index) => {
            if (index === dvrIndex) return item;
            return value;
          }
        ),
      })
    );
  };

  return (
    <CollapsableContent
      icon={<Cloud />}
      header={<p>Cloud DVR</p>}
      count={(operator.mediaFirstSettings?.cloudDvrs ?? []).length}
      customAction={
        <CsvImportButton<CreateCloudDvr>
          canOverwrite={true}
          settingName="Cloud DVRs"
          requiredColumns={[
            { name: 'description', type: 'string' },
            { name: 'mediafirstId', type: 'string' },
            { name: 'featureSubscriptionId', type: 'string' },
          ]}
          onImport={(csv, overwrite) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                cloudDvrs: overwrite
                  ? csv
                  : [...csv, ...(operator.mediaFirstSettings?.cloudDvrs ?? [])],
              })
            )
          }
        />
      }
      padding="sm"
    >
      <div className={classes.container}>
        <DynamicForm<CreateCloudDvr>
          defaultForm={{
            active: true,
            description: '',
            mediafirstId: '',
            featureSubscriptionId: '',
          }}
          inputs={[
            {
              order: 0,
              rowInputs: [
                {
                  props: {
                    name: 'description',
                    label: 'Description',
                    required: false,
                    value: (values) => values.description,
                  },
                },
              ],
            },
            {
              order: 1,
              rowInputs: [
                {
                  props: {
                    name: 'mediafirstId',
                    label: 'MediaFirst ID',
                    required: false,
                    value: (values) => values.mediafirstId,
                  },
                },
                {
                  props: {
                    name: 'featureSubscriptionId',
                    label: 'Subscription ID',
                    required: false,
                    value: (values) => values.featureSubscriptionId,
                  },
                },
              ],
            },
          ]}
          submitButton={{ text: 'Add Cloud DVR' }}
          validation={(values) =>
            (values.description ?? '').trim() !== '' &&
            (values.mediafirstId ?? '').trim() !== '' &&
            (values.featureSubscriptionId ?? '').trim() !== ''
          }
          onSubmit={(values) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                cloudDvrs: [
                  values,
                  ...(operator.mediaFirstSettings?.cloudDvrs ?? []),
                ],
              })
            )
          }
        />
        <SettingItemList<CreateCloudDvr>
          name="Cloud DVR's"
          items={operator.mediaFirstSettings?.cloudDvrs ?? []}
          renderRow={(item, index) => (
            <CloudDvr
              index={index}
              cloudDvr={item}
              onRemove={handleRemovePkg}
              onSave={handleSavePkg}
            />
          )}
        />
      </div>
    </CollapsableContent>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center w-full',
  inputs: 'inline-flex items-center gap-4',
});
